/* tslint:disable */
/* eslint-disable */
/**
 * Notifications API
 * An API to create and read notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: DevTeamProduct@digitalrealty.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime.js';
/**
 * Request body for creating a notification
 * @export
 * @interface NotificationRequest
 */
export interface NotificationRequest {
    /**
     * Type of notification to be sent to the user
     * @type {string}
     * @memberof NotificationRequest
     */
    resourceType: string;
    /**
     * Sub grouping of the notification
     * @type {string}
     * @memberof NotificationRequest
     */
    subGroup?: string;
    /**
     * List of recipients of the notification
     * @type {Array<string>}
     * @memberof NotificationRequest
     */
    recipients?: Array<string>;
    /**
     * Account number of the notification
     * @type {string}
     * @memberof NotificationRequest
     */
    accountNumber: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationRequest
     */
    locations?: Array<string>;
    /**
     * Unique identifier the notification refers to
     * @type {string}
     * @memberof NotificationRequest
     */
    resourceId: string;
    /**
     * Description text of the notification
     * @type {string}
     * @memberof NotificationRequest
     */
    subject: string;
    /**
     * Created date
     * @type {Date}
     * @memberof NotificationRequest
     */
    createdAt?: Date | null;
}

/**
 * Check if a given object implements the NotificationRequest interface.
 */
export function instanceOfNotificationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resourceType" in value;
    isInstance = isInstance && "accountNumber" in value;
    isInstance = isInstance && "resourceId" in value;
    isInstance = isInstance && "subject" in value;

    return isInstance;
}

export function NotificationRequestFromJSON(json: any): NotificationRequest {
    return NotificationRequestFromJSONTyped(json, false);
}

export function NotificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resourceType': json['resource_type'],
        'subGroup': !exists(json, 'sub_group') ? undefined : json['sub_group'],
        'recipients': !exists(json, 'recipients') ? undefined : json['recipients'],
        'accountNumber': json['account_number'],
        'locations': !exists(json, 'locations') ? undefined : json['locations'],
        'resourceId': json['resource_id'],
        'subject': json['subject'],
        'createdAt': !exists(json, 'created_at') ? undefined : (json['created_at'] === null ? null : new Date(json['created_at'])),
    };
}

export function NotificationRequestToJSON(value?: NotificationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resource_type': value.resourceType,
        'sub_group': value.subGroup,
        'recipients': value.recipients,
        'account_number': value.accountNumber,
        'locations': value.locations,
        'resource_id': value.resourceId,
        'subject': value.subject,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt === null ? null : value.createdAt.toISOString()),
    };
}

